import { fetchClient } from '@/util/fetchClient';

export async function deleteAttachmentV2(params: {
  s3Key: string;
  conversationId: string;
  messageId: string;
}) {
  const { s3Key, conversationId, messageId } = params;

  try {
    const { data } = await fetchClient.DELETE('/v2/attachments/{s3Key}', {
      params: {
        path: {
          s3Key,
        },
      },
      body: {
        conversationId,
        messageId,
      },
    });

    return data;
  } catch (error) {
    throw error;
  }
}
